import React from "react"
import {Col, Layout, Row, Space, Spin} from "antd";
import './styles.css';
import HowToGetRewardedStaticComponent from "./how-to-get-rewarded-static.component";
import FooterComponent from "../../../components/footer/footer";
import {useMediaQuery} from "react-responsive";
import MobileFooterComponent from "../../../components/footer/mobile-footer";
import TopCarouselComponentTwo from "../../../components/top-carousel/top-carousel-component-two";
import OurMerchants from "./our-merchants.component";
import Download from "./download-icons.component"
import RewardsOnOfferComponent from "./rewards-on-offer/rewards-on-offer.component";
import freezoneLogo from "../../../assets/images/freezone-logo.svg"

const {Header, Content} = Layout
const StaticScreen = () => {
    const isMobile = useMediaQuery({query: '(max-width: 560px)'})

    return (
        <Layout style={{maxWidth: 1366, backgroundColor: '#FFFFFF', marginLeft: "auto", marginRight: "auto"}}>
            <Header style={{backgroundColor: "#FFFFFF", position: "fixed", width: "100%", maxWidth: 1366, zIndex: 5}}>
                <img src={freezoneLogo} alt="logo" style={{marginRight: 250, marginLeft: -50, height: 64}}/>
            </Header>
            <Spin spinning={false} size={"large"}>
                <div style={{paddingTop: "64px"}}/>
                <TopCarouselComponentTwo type={"STATIC"}/>
                {/*<Content
                    style={isMobile ? {paddingInline: '16px'} : {paddingInline: "69px"}}>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <RewardsOnOfferComponent/>
                        </Col>
                    </Row>
                    <Space/>
                </Content>*/}
            </Spin>
            {/*<Row>
                <Col className="gutter-row" span={24} style={{backgroundColor: '#000000'}}>
                    <HowToGetRewardedStaticComponent/>
                </Col>
            </Row>
            <Row>
                <Col className="gutter-row" span={24} style={{backgroundColor: '#FFFFFF'}}>
                    <OurMerchants/>
                </Col>
            </Row>*/}
            <Row>
                <Col className="gutter-row" span={24}
                     style={{backgroundColor: '#E0E0E0', paddingTop: "40px", paddingBottom: "40px"}}>
                    <Download/>
                </Col>
            </Row>
            {/*{
                isMobile ?
                    <MobileFooterComponent/>
                    : <FooterComponent/>
            }*/}
        </Layout>
    )
};
export default StaticScreen;
